<template>
  <div class="lotus_content">
    <section class="box_page_content_2">
      <h3>{{ $t("history.title") }}</h3>
      <div class="box3">
        <div class="_inbox">
          <div class="_inbox1">
            <div class="listing_x">
              <template v-if="histories && histories.length > 0">
                <div
                  class="_item"
                  v-for="(history, index) in histories"
                  :key="history.id"
                >
                  <div class="_t">
                    {{ $t("history.step", { step: generateStt(index) }) }}
                  </div>
                  <ul class="list-unstyled">
                    <li>
                      <span>{{ $t("history.joinDate") }}:</span>
                      <label>{{
                        convertTimestampToDate(history.created)
                      }}</label>
                    </li>
                    <li>
                      <span>{{ $t("history.transactionCode") }}:</span>
                      <label class="text-align-right">{{
                        history.transaction_id
                      }}</label>
                    </li>
                    <li>
                      <span>{{ $t("history.gift") }}:</span>
                      <template v-if="history.reward">
                        <label class="text-align-right">{{
                          history.reward.name
                        }}</label>
                      </template>
                    </li>
<!--                    <li>-->
<!--                      <span>{{ $t("history.linkGetGift") }}:</span>-->
<!--                      <template v-if="history.reward.type === voucherType">-->
<!--                        <a class="a-span" href="javascript:;"> Thành công </a>-->
<!--                      </template>-->
<!--                      <template v-if="history.reward.type === physicalType">-->
<!--                        <a-->
<!--                          v-if="-->
<!--                            history.delivery_code &&-->
<!--                            history.delivery_code === shippingStatus-->
<!--                          "-->
<!--                          class="a-span"-->
<!--                          href="javascript:;"-->
<!--                        >-->
<!--                          Đang giao hàng-->
<!--                        </a>-->
<!--                        <a-->
<!--                          v-else-if="-->
<!--                            history.delivery_code &&-->
<!--                            history.delivery_code === successStatus-->
<!--                          "-->
<!--                          class="a-span success"-->
<!--                          href="javascript:;"-->
<!--                        >-->
<!--                          Thành công-->
<!--                        </a>-->
<!--                        <a-->
<!--                          v-else-if="-->
<!--                            history.delivery_code &&-->
<!--                            history.delivery_code === returnStatus-->
<!--                          "-->
<!--                          class="a-span orange"-->
<!--                          href="javascript:;"-->
<!--                        >-->
<!--                          Confirm trả hàng-->
<!--                        </a>-->
<!--                        <a v-else class="a-span orange" href="javascript:;">-->
<!--                          Đang xử lý-->
<!--                        </a>-->
<!--                      </template>-->
<!--                    </li>-->

                    <!--                    <li>-->
                    <!--                      <span>{{ $t("history.linkGetGift") }}:</span>-->
                    <!--                      <template v-if="history.state === stateBlock">-->
                    <!--                        <a class="a-span" href="javascript:;">{{-->
                    <!--                            $t("history.state_1")-->
                    <!--                          }}</a>-->
                    <!--                      </template>-->
                    <!--                      <template v-else-if="history.state === stateReady">-->
                    <!--                        <a class="a-span" href="javascript:;">{{-->
                    <!--                            $t("history.state_2")-->
                    <!--                          }}</a>-->
                    <!--                      </template>-->

                    <!--                      <template-->
                    <!--                          v-else-if="-->
                    <!--                          history.state === stateGot &&-->
                    <!--                          history.cart_status.is_exist_detail-->
                    <!--                        "-->
                    <!--                      >-->
                    <!--                        <a-->
                    <!--                            :href="history.cart_status.detail[0].link"-->
                    <!--                            target="_blank"-->
                    <!--                        >{{ $t("history.viewGift") }}</a-->
                    <!--                        >-->
                    <!--                      </template>-->
                    <!--                      <template-->
                    <!--                          v-else-if="-->
                    <!--                          history.state === stateGot &&-->
                    <!--                          !history.cart_status.is_exist_detail-->
                    <!--                        "-->
                    <!--                      >-->
                    <!--                        <a class="a-span" href="javascript:;">{{-->
                    <!--                            $t("history.state_2")-->
                    <!--                          }}</a>-->
                    <!--                      </template>-->
                    <!--                      <template v-else-if="history.state === stateFail">-->
                    <!--                        <a-->
                    <!--                            href="javascript:;"-->
                    <!--                            v-on:click="retryGift(history.id, index)"-->
                    <!--                        >{{ $t("history.linkRetry") }}</a-->
                    <!--                        >-->
                    <!--                      </template>-->
                    <!--                    </li>-->
                  </ul>
                </div>
              </template>
              <div
                v-else
                class="mt-1 mb-4 text-center"
                style="white-space: pre-line"
              >
                {{ $t("history.empty_history") }}
              </div>
            </div>
            <div class="_foot text-center">
              <router-link
                :to="{ name: 'luckyDraw' }"
                tag="a"
                class="btn btn-x2"
              >
                <span>{{ $t("history.button") }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--FOOTER-->
    <footer class="d-flex flex-wrap px-content-1">
      <p class="flex-grow-1">
        Hotline: <a href="tel:1900299232">1900 299 232</a>
      </p>
      <p>
        <a href="#" class="d-flex align-items-center">
          <img src="@/assets/images/ub_logo.svg" />
          <span>Powered by UrBox</span>
        </a>
      </p>
    </footer>
  </div>
</template>

<script>
import { HISTORY, RETRY_GIFT, USER_INFO, GIFT_LIST } from "@/stores/actions";
import { mapGetters } from "vuex";
import { historyEnum } from "@/enums";
import JwtService from "@/jwt-service";
import { GAME_APP } from "@/enums";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "History",
  created() {
    let vm = this;
    vm.getHistory();
  },
  computed: {
    ...mapGetters(["histories", "totalHistory"]),
    shippingStatus() {
      return historyEnum.SHIPPING;
    },
    successStatus() {
      return historyEnum.SUCCESS;
    },
    returnStatus() {
      return historyEnum.RETURN;
    },
    voucherType() {
      return historyEnum.VOUCHER_TYPE;
    },
    physicalType() {
      return historyEnum.PHYSICAL_TYPE;
    },
  },
  mounted() {
    let vm = this;
    vm.$root.$on("draw_success", function () {
      vm.isDrawReload = true;
      vm.isLoadHistory = true;
      vm.reloadAllHistory();
    });
    vm.$root.$on("change-language", function (locale) {
      vm.currentLang = locale;
      vm.reloadAllHistory();
    });
    window.onscroll = function () {
      if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
        vm.loadHistory();
      }
    };
    //vm.getUserInfo();
    vm.getGiftList();
  },
  data() {
    return {
      page: 0,
      retryPage: -1,
      isRetry: {},
      per_page: 20,
      currentLang: this.$i18n.locale,
      isDrawReload: false,
      isLoadHistory: false,
      isReload: {
        vi: false,
        en: false,
      },
      customerPhone: this.$route.params.customerPhone,
    };
  },
  methods: {
    getUserInfo(isRetry = 0) {
      let vm = this;
      vm.$store
        .dispatch(USER_INFO, {
          game_id: GAME_APP.ID,
          app_id: GAME_APP.APP_ID,
          customer_id: vm.customerPhone,
        })
        .then((res) => {
          if (res && res.status !== 200) {
            if (isRetry === 0) {
              vm.getUserInfo(1);
            } else {
              console.log(res);
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getGiftList(isRetry = 0) {
      let vm = this;
      vm.$store
        .dispatch(GIFT_LIST, { game_id: GAME_APP.ID, app_id: GAME_APP.APP_ID })
        .then((res) => {
          if (res && res.status !== 200) {
            if (isRetry === 0) {
              vm.getGiftList(1);
            }
          }
        })
        .catch(() => {
          if (isRetry === 0) {
            vm.getGiftList(1);
          }
        });
    },
    generateStt(index) {
      let vm = this;
      return vm.histories .length- index;
    },

    reloadAllHistory() {
      let vm = this;
      for (let key in Array.from(Array(vm.page + 1).keys())) {
        vm.getHistory(0, key);
      }
    },

    loadHistory() {
      let vm = this;
      let numMax = Math.floor(vm.totalHistory / vm.per_page);
      if (vm.page < numMax) {
        vm.page = vm.page + 1;
        vm.getHistory();
      }
    },

    retryGift(id, index) {
      let vm = this;
      if (vm.isRetry[id]) {
        return false;
      }
      vm.retryPage = Math.floor(index / vm.per_page);
      vm.isRetry[id] = true;
      vm.$store
        .dispatch(RETRY_GIFT, { id: id, game_id: GAME_APP.ID })
        .then((res) => {
          if (res && res.status === 200) {
            vm.loadHistory();
          }
        })
        .catch(() => {
          console.log();
        });
    },
    generateClassByDeliveryCode(code) {
      if ([1, 2, 5, 6, 7, 10].includes(code)) {
        return "text_warning";
      } else if ([4, 11].includes(code)) {
        return "text_danger";
      } else {
        return "text_success";
      }
    },
    generateDeliveryByCode(code) {
      let vm = this;
      switch (code) {
        case 1:
          return vm.$t("history.delivery_1");
        case 2:
          return vm.$t("history.delivery_2");
        case 3:
          return vm.$t("history.delivery_3");
        case 4:
          return vm.$t("history.delivery_4");
        case 5:
          return vm.$t("history.delivery_5");
        case 6:
          return vm.$t("history.delivery_6");
        case 7:
          return vm.$t("history.delivery_7");
        case 8:
          return vm.$t("history.delivery_8");
        case 9:
          return vm.$t("history.delivery_9");
        case 10:
          return vm.$t("history.delivery_10");
        case 11:
          return vm.$t("history.delivery_11");
      }
    },
    getHistory() {
      let vm = this;
      vm.$store
        .dispatch(HISTORY, {
          game_id: GAME_APP.ID,
          app_id: GAME_APP.APP_ID,
          customer_id: JwtService.getCustomerPhone(),
        })
        .then((res) => {
          if (res && res.status !== 200) {
            // vm.getHistory(1);
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.a-span {
  text-decoration: none;
  color: #1f36c7;
  cursor: default;
}
.orange {
  color: #ff9500 !important;
}
.success {
  color: #08a965 !important;
}
.text-align-right {
  max-width: 60%;
  text-align: right;
}
</style>
